/**
 * The Cybercore system account.
 *
 * A sentinel owner id (NOT a real Firebase Auth user) that holds canonical
 * game data — properties, items, effects, origins, legacies, homeworlds — once
 * that data is made Public. When a user makes something public, ownership
 * transfers to this account so the content survives even if the original
 * author deletes their profile. It is also the fallback owner for any
 * non-public game data a departing user leaves behind.
 *
 * Keep this value in sync with SYSTEM_OWNER_UID in functions/src/helpers.ts.
 */
export const SYSTEM_OWNER_UID = 'cybercore-system';

/** True when the given owner id is the shared system account. */
export const isSystemOwned = (ownerId: string | undefined | null): boolean =>
	ownerId === SYSTEM_OWNER_UID;
